var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportsSaved = function SvgReportsSaved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 53.26,
    y1: 171.35,
    x2: 159.12,
    y2: 50.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 28.68,
    y1: 149.81,
    x2: 134.53,
    y2: 29.01,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 63.7,
    y1: 180.5,
    x2: 169.55,
    y2: 59.7,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 79.35,
    y1: 194.21,
    x2: 185.21,
    y2: 73.42,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M31.58,0v94.74H0v68.42C0,181.72,13.73,197.06,31.58,199.62v.38h168.42V0H31.58ZM10.53,163.16v-57.89h21.05v84.21c-12.45-2.54-21.31-13.61-21.05-26.32ZM189.47,189.47H42.11V10.53h147.37v178.95Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,105.26c20.35,0,36.84-16.49,36.84-36.84s-16.49-36.84-36.84-36.84-36.84,16.49-36.84,36.84,16.49,36.84,36.84,36.84ZM105.26,94.21v-20.53h20.53c-2.09,10.31-10.21,18.43-20.53,20.53ZM100,42.11c12.73,0,23.35,9.04,25.79,21.05h-31.05v31.05c-12.01-2.44-21.05-13.06-21.05-25.79,0-14.53,11.78-26.32,26.32-26.32Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.16,
    y: 115.79,
    width: 105.26,
    height: 10.53,
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.16,
    y: 147.37,
    width: 105.26,
    height: 10.53,
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }));
};
export default SvgReportsSaved;